export default __webpack_public_path__ + "static/media/ITS.b22fc85b.png";